import { Component, OnInit } from '@angular/core';
import { faCookieBite } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-cookie',
  templateUrl: './cookie.component.html',
  styleUrls: ['./cookie.component.scss']
})
export class CookieComponent implements OnInit {

  get titleLabel(){ return "Informativa cookie" }
  get titleIcon(){ return faCookieBite }

  constructor() { }

  ngOnInit(): void {
  }

}
